import React, { FC, useEffect, useRef, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
  Alert,
  Button,
  Form,
  FormControl,
  InputGroup,
  Modal,
} from 'react-bootstrap';

interface GuestLinkModalProps {
  isVisible: boolean;
  onClose: () => void;
  guestLink: string;
}

export const GuestLinkModal: FC<GuestLinkModalProps> = ({
  isVisible,
  onClose,
  guestLink,
}) => {
  const guestLinkInputRef = useRef<HTMLInputElement>(null);
  const [isAlertVisible, setIsAlertVisible] = useState<boolean>(false);

  useEffect(() => {
    if (isAlertVisible) {
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 2000);
    }
  }, [isAlertVisible]);

  useEffect(() => {
    if (isVisible) {
      guestLinkInputRef.current?.select();
    }
  }, [isVisible, guestLink]);

  return (
    <Modal show={isVisible} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Invite guests</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Label htmlFor="guest-link">
          Use this link to invite guests to your stream
        </Form.Label>
        <Alert
          dismissible
          show={isAlertVisible}
          variant="success"
          onClose={() => setIsAlertVisible(false)}
        >
          Guest link copied to clipboard
        </Alert>
        <InputGroup>
          <FormControl
            readOnly
            id="guest-link"
            type="text"
            value={guestLink}
            ref={guestLinkInputRef}
          />
          <InputGroup.Append>
            <CopyToClipboard
              text={guestLink}
              onCopy={() => setIsAlertVisible(true)}
            >
              <Button variant="outline-primary">Copy</Button>
            </CopyToClipboard>
          </InputGroup.Append>
        </InputGroup>
      </Modal.Body>
    </Modal>
  );
};
